import { render } from "./ProductsCrowdsurancePage.vue?vue&type=template&id=4d2cb76e&scoped=true"
import script from "./ProductsCrowdsurancePage.vue?vue&type=script&lang=js"
export * from "./ProductsCrowdsurancePage.vue?vue&type=script&lang=js"

import "./ProductsCrowdsurancePage.vue?vue&type=style&index=0&id=4d2cb76e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2cb76e"]])

export default __exports__